import { cn } from '@/lib/utils';

interface ReadingProgressProps {
  progress: number;
  className?: string;
}

export function ReadingProgress({ progress, className }: ReadingProgressProps) {
  // Don't show progress bar if at 0% or 100%
  if (progress <= 0 || progress >= 100) {
    return null;
  }

  return (
    <div className={cn('fixed top-0 left-0 right-0 z-50 h-1 bg-muted/50', className)}>
      <div
        className="h-full bg-primary transition-[width] duration-150 ease-out"
        style={{ width: `${progress}%` }}
        role="progressbar"
        aria-valuenow={Math.round(progress)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Reading progress"
      />
    </div>
  );
}
